/**
 * Card layout dimensions for NoteCard components in grid views.
 * These values ensure consistent sizing across NoteCard, SkeletonCard,
 * and LoadingCard components, as well as grid calculations in NotesContent.
 */
export const CARD_DIMENSIONS = {
  /** Standard card height matching NoteCard component (240px) */
  HEIGHT: 240,
  /** Standard card width for grid layout (250px) */
  WIDTH: 250,
  /** Gap between cards, equivalent to theme.spacing(2) (16px) */
  MARGIN: 16,
  /** Height of the card thumbnail/media section (140px) */
  THUMBNAIL_HEIGHT: 140,
} as const;

export type CardDimensions = typeof CARD_DIMENSIONS;

/**
 * List row dimensions for NoteListRow components in list views.
 * These values ensure consistent sizing across NoteListRow, SkeletonListRow,
 * and NoteListHeader components, as well as limit calculations in NotesContent.
 */
export const LIST_ROW_DIMENSIONS = {
  /** Height for list rows without thumbnail (48px) */
  EXPANDED_HEIGHT: 48,
  /** Height for expanded list rows with thumbnail (80px) */
  EXPANDED_WITH_THUMBNAIL_HEIGHT: 80,
  /** Thumbnail square size in expanded list rows (56px) */
  THUMBNAIL_SIZE: 56,
  /** Thumbnail border radius (8px) */
  THUMBNAIL_BORDER_RADIUS: 8,
} as const;

export type ListRowDimensions = typeof LIST_ROW_DIMENSIONS;
